import { render, staticRenderFns } from "./PartyBuildingTestEdit.vue?vue&type=template&id=30e568c8&"
import script from "./PartyBuildingTestEdit.vue?vue&type=script&lang=js&"
export * from "./PartyBuildingTestEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports